import { faultSymptomsCallBlock } from './fault-symptoms'
import { isStrayCypherExpr } from './stray'

/**
 * Detail bundle for a single `:Part` (`$partId` param).
 *
 * Factory breadcrumb context is intentionally limited to a directly hosting
 * Equipment. Parent-Part-only and `LOCATED_IN` paths remain Model-browser
 * concerns rather than inventing a factory placement.
 */
export const PLANT_PART_DETAIL_CYPHER = `
  MATCH (p:Part {id: $partId})

  CALL {
    WITH p
    OPTIONAL MATCH (owner)-[hp:HAS_PART]->(p)
      WHERE owner:Equipment OR owner:Part
    WITH p, [row IN collect(DISTINCT {
      owner: owner,
      ownerLabels: labels(owner),
      edge: {
        type: type(hp),
        source: owner.id,
        target: p.id,
        props: properties(hp)
      }
    }) WHERE row.owner IS NOT NULL] AS inbound
    RETURN inbound AS usedIn
  }

  CALL {
    WITH p
    OPTIONAL MATCH (p)-[hp:HAS_PART]->(child:Part)
    RETURN [row IN collect(DISTINCT {
      part: child,
      edge: {
        type: type(hp),
        source: p.id,
        target: child.id,
        props: properties(hp)
      }
    }) WHERE row.part IS NOT NULL] AS subParts
  }

  CALL {
    WITH p
    OPTIONAL MATCH (p)-[:MANUFACTURED_BY]->(manufacturer:Vendor)
    WITH p, [v IN collect(DISTINCT manufacturer) WHERE v IS NOT NULL] AS manufacturers
    OPTIONAL MATCH (p)-[:SUPPLIED_BY]->(supplier:Vendor)
    WITH manufacturers, [v IN collect(DISTINCT supplier) WHERE v IS NOT NULL] AS suppliers
    RETURN [v IN manufacturers | { vendor: v, role: 'manufacturer' }] +
           [v IN suppliers | { vendor: v, role: 'supplier' }] AS vendors
  }

  CALL {
    WITH p
    OPTIONAL MATCH (procedure:Procedure)-[rp:REQUIRES_PART]->(p)
    RETURN [row IN collect(DISTINCT {
      procedure: procedure,
      edge: {
        type: type(rp),
        source: procedure.id,
        target: p.id,
        props: properties(rp)
      }
    }) WHERE row.procedure IS NOT NULL] AS procedures
  }

${faultSymptomsCallBlock('p')}

  CALL {
    WITH p
    OPTIONAL MATCH (p)-[:LOCATED_IN]->(location)
      WHERE location:Area OR location:FunctionalLocation
    RETURN [row IN collect(DISTINCT {
      location: location,
      locationLabels: labels(location)
    }) WHERE row.location IS NOT NULL] AS locations
  }

  CALL {
    WITH p
    OPTIONAL MATCH (directEquipment:Equipment)-[:HAS_PART]->(p)
    WITH p,
         [eq IN collect(DISTINCT directEquipment) WHERE eq IS NOT NULL] AS directEquipmentRows
    WITH head(directEquipmentRows) AS equipment
    OPTIONAL MATCH (equipment)<-[:HAS_EQUIPMENT]-(line:Line)
    OPTIONAL MATCH (line)<-[:HAS_SUBLINE*0..20]-(:Line)<-[:HAS_LINE]-(site:Site)
    RETURN equipment,
           head(collect(DISTINCT line)) AS line,
           head(collect(DISTINCT site)) AS site
  }

  RETURN p, usedIn, subParts, vendors, procedures, faults, locations,
         equipment, line, site,
         ${isStrayCypherExpr('p', 'Part')} AS isStray
  LIMIT 10000
`
